import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Admin1/Pages/admin1.css';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';

const SubscriptionManag = () => {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filterType, setFilterType] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedExtensions, setSelectedExtensions] = useState({});

  const rowsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('No authentication token found');
          setLoading(false);
          return;
        }

        const response = await axios.get(
          'https://api.safree.org/api-v2022/superAdmin/auth/v1/users/subscriptions',
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setUsers(response.data.data);
          setFilteredUsers(response.data.data); // Set initial filtered data
        } else {
          setError('Failed to fetch users');
        }
      } catch (err) {
        console.error('Error fetching users:', err);
        setError('An error occurred while fetching users: ' + err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Filter change handler
  useEffect(() => {
    if (filterType === 'All') {
      setFilteredUsers(users);
    } else {
      const filtered = users.filter(user => user.subscriptionType === filterType);
      setFilteredUsers(filtered);
      setCurrentPage(1); // Reset to first page
    }
  }, [filterType, users]);

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const currentRows = filteredUsers.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (direction) => {
    if (direction === 'prev' && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
    if (direction === 'next' && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const getPageNumbers = () => {
    const maxPageNumbersToShow = 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    const endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  };

  const handleExtensionChange = async (userId, extension) => {
    setSelectedExtensions((prev) => ({
      ...prev,
      [userId]: extension,
    }));

    if (extension) {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
          'https://api.safree.org/api-v2022/superAdmin/auth/v1/extend/users/trial-plan',
          {
            userId,
            duration: extension,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          alert('Trial plan extended successfully!');
        } else {
          alert('Failed to extend trial plan.');
        }
      } catch (error) {
        console.error('Error extending trial plan:', error);
        alert('An error occurred while extending the trial plan.');
      }
    }
  };

  if (loading) return <div className='loading'><img src={Loader} alt="loading..." /></div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container user-management">
      <div className="row header">
        <div className="col-md-6">
          <p className="sub-heading">Subscription Management</p>
        </div>
        <div className="col-md-6 text-end">
          <select
            className="form-select filter-dropdown"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Premium">Premium</option>
            <option value="Basic">Basic</option>
          </select>
        </div>
      </div>

      <div className="table-container">
        <table className="styled-table">
          <thead>
            <tr>
              <th>S. No</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Current Plan</th>
              <th>Plan Expiry</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((user, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.phoneNumber}</td>
                <td>{user.subscriptionType}</td>
                <td className='expiryplan'>
                  {user.subscriptionExpiryDate}
                  {(user.subscriptionType === 'Basic' || (user.subscriptionType === 'Premium' && user.isTrialPlan)) && (
                    <select
                      className="extend-trial-dropdown"
                      value={selectedExtensions[user.userId] || ''}
                      onChange={(e) => handleExtensionChange(user.userId, e.target.value)}
                    >
                      <option value="">{user.currentTrialPlan}</option>
                      <option value="1 Month">1 Month</option>
                      <option value="3 Months">3 Months</option>
                      <option value="6 Months">6 Months</option>
                      <option value="1 Year">1 Year</option>
                    </select>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="pagination-container">
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('prev')}
            disabled={currentPage === 1}
          >
            &laquo; Prev
          </button>
          {getPageNumbers().map((page) => (
            <button
              key={page}
              className={`pagination-btn ${currentPage === page ? 'active' : ''}`}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-btn"
            onClick={() => handlePageChange('next')}
            disabled={currentPage === totalPages}
          >
            Next &raquo;
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionManag;
